import { State } from "infrontjs";

import { IndexState } from "./../index/IndexState";

export class AuthState extends State
{
    static ROUTE = null;
    static ID = null;

    canEnter()
    {
        if ( this.app.user === null )
        {
            return true
        }
        else
        {
            return false;
        }
    }

    getRedirectUrl()
    {
        return IndexState.ROUTE;
    }

}
